module.exports = __webpack_public_path__ + "static/media/React-logo.c03e9278.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/React-logo.png
// module id = 159
// module chunks = 0